import React from "react";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

import { StyledItemsPerPage } from "./styledFiter";

import { DEFAULT_ITEMS_PER_PAGE_VALUE } from "../../../utils/consts";

const ItemsPerPageSelect = ({ itemsPerPage, setItemsPerPage }) => {
  const { t } = useTranslation("otherInterface");

  const handleChangeSelect = (event) => {
    let data = event.target.value;
    setItemsPerPage(data);
    Cookies.set("itemsPerPage", data);
  };

  const itemsPerPageValues = [10, 20, 50, 100];

  return (
    <StyledItemsPerPage>
      {itemsPerPage !== undefined && (
        <FormControl variant="outlined">
          <InputLabel id="service-simple-select-label">{t("itemsPerPageSelect.description")}</InputLabel>
          {/* No need to change on Autocomplete component (items per page) */}
          <Select
            labelId="items-per-page-simple-select-label"
            id="items-per-page-simple-select"
            value={itemsPerPage}
            onChange={handleChangeSelect}
          >
            {<MenuItem value={DEFAULT_ITEMS_PER_PAGE_VALUE}>
              {t("itemsPerPageSelect.default")}
            </MenuItem>}
            {itemsPerPageValues.map((value) => (
              <MenuItem
                key={value}
                value={value}
              >
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </StyledItemsPerPage>
  );
};

export default ItemsPerPageSelect;